import axios from "axios";
import { AuthModel, UserModel, AddOperatorModal, getClientDataModal, updateClientDataModal, updateClientPasswordDataModal } from "./_models";
import { getPayloadHash } from "./axiosWithHawk";

/* Base URL for Fetching API*/
export const API_URL = `${process.env.REACT_APP_API_URL_V1}/api/v1/hq`;
/* Base URL for Fetching API*/

/*HQ Panel base URL */
//const API_BASE_URL = process.env.HQ_PANEL_BASE_URL;
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verify_token`;
export const REGISTER_URL = `${API_URL}/register`;
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`;

/* Admin login API endpoint*/
export const LOGIN_URL = `${API_URL}/admin/admin_login`;
/* Admin login API endpoint*/

/*Add GAME category form Submit Endpoint*/
export const ADD_GAME_CATEGORY_FORM_SUBMIT = `${API_URL}/category/add-category`;
/*Add Game category form Submit Endpoint*/

/*Delete GAME category List API Endpoint*/
export const DELETE_GAME_CATEGORY = `${API_URL}/category/delete-category`;
/*Delete GAME category List API Endpoint*/

/*Delete GAME category List API Endpoint*/
export const CHANGE_STATUS_GAME_CATEGORY = `${API_URL}/category/category-status-toggle`;
/*Delete GAME category List API Endpoint*/

/*Get Edit Game Category Form Fields API Endpoint*/
export const GET_EDIT_GAME_CATEGORY_FORM_FIELDS = `${API_URL}/category/category-details`;
/*Get Edit Game Category Form Fields API Endpoint*/

/*Submit Edit Game Category Form Fields API Endpoint*/
export const SUBMIT_EDIT_GAME_CATEGORY_FORM_FIELDS = `${API_URL}/category/edit-category`;
/*Submit Edit Game Category Form Fields API Endpoint*/
/*All Game Category APIs service endpoint*/

/*Get Add Game Category Form Fields API Endpoint*/
export const GET_ADD_GAME_CATEGORY_FORM_FIELDS = `${API_URL}/lang-list`;
/*Get Add Game Category Form Fields API Endpoint*/

//! Api End Point For Search Client Component
/*Search Operator API Endpoint URL*/
export const SEARCH_USER_CLIENT = `${API_URL}/search_client_user`;
export const NAVIGATE_ALL_CLIENT_LIST = `${API_URL}/client/redirect-to-client-list`;
/*Search Operator API Endpoint URL*/
//! Api End Point For Search Client Component

//! Api End Point For Client Component

/*Add new Client form Submit Endpoint*/
export const ADD_NEW_CLIENT_FORM_SUBMIT = `${API_URL}/client/add_client`;
/*Add new Client  form Submit Endpoint*/

/*Get Account General API Endpoint*/
export const GET_OPERATOR_ACCOUNT_GENERAL = `${API_URL}/account/get-account`;
/*Get Account General API Endpoint*/

/*Update Account General API Endpoint*/
export const UPDATE_ACCOUNT_GENERAL = `${API_URL}/account/update-account`;
/*Update Account General API Endpoint*/

/*Get Account General API Endpoint*/
export const GET_OPERATOR_ACCOUNT_TECHINICAL = `${API_URL}/account/get-account-technicals`;
/*Get Account General API Endpoint*/

/*Update Account General API Endpoint*/
export const UPDATE_ACCOUNT_TECHINICAL = `${API_URL}/account/update-account-technicals`;
/*Update Account General API Endpoint*/
/*Get Account List API Endpoint*/
export const GET_ACCOUNT = `${API_URL}/account/show_account`;
/*Get Account List API Endpoint*/

/*Update Account General API Endpoint*/

/*Update Account General API Endpoint*/

export const GET_CLIENT_ACCOUNT_REVENUE_SETTING = `${API_URL}/account/revenue-setting`;

export const UPDATE_CLIENT_ACCOUNT_REVENUE_SEETING = `${API_URL}/account/update-revenue-setting`;
export const GET_ASSIGN_PROVIDER_ACCOUNT_LIST = `${API_URL}/account/assign-provider-account-list`;


export const ASSIGN_PROVIDER_ACCOUNT = `${API_URL}/account/assign-provider-account`;

export const GET_CLIENT_ACCOUNT_BALANCE = `${API_URL}/wallet/get-account-balance`;

export const TRANSFER_CLIENT_ACCOUNT_BALANCE = `${API_URL}/wallet/transfer-balance-to-account`;

export const DEDUCT_CLIENT_ACCOUNT_BALANCE_CONFIRM = `${API_URL}/wallet/confirm-deduct-balance`;

export const DEDUCT_CLIENT_ACCOUNT_BALANCE = `${API_URL}/wallet/deduct-balance`;
//! Api End Point For Client Component
/*All Game List API endpoints */
/*Get Provider List API */
export const GET_PROVIDER_LIST = `${API_URL}/provider/provider-list`;
/*Get Provider List API */

/*Get Search Game List API */
export const GET_SEARCH_GAME_LIST = `${API_URL}/games/game-list`;
/*Get Search Game List API */

/*Delete GAME List API Endpoint*/
export const DELETE_GAME_LIST_ITEM = `${API_URL}/games/game-delete`;
export const DELETE_ALL_ERROR_GAMES = `${API_URL}/games/delete-all-error-games`;
/*Delete GAME List API Endpoint*/

/*Change GAME category List Item Status API Endpoint*/
export const CHANGE_STATUS_GAME_LIST = `${API_URL}/games/game-status-toggle`;
/*Change GAME category List Item Status API Endpoint*/

/*Load GAME MODIFY FORM DATA API Endpoint*/
export const MODIFY_GAME_DATA_FORM_LOAD_API = `${API_URL}/games/game-details`;
/*Load GAME MODIFY FORM DATA API Endpoint*/

/*SUBMIT GAME MODIFY FORM DATA API Endpoint*/
export const MODIFY_GAME_DATA_FORM_SUBMIT_API = `${API_URL}/games/game-edit`;
/*SUBMIT GAME MODIFY FORM DATA API Endpoint*/

export const UPDATE_GAME_IMAGE_API_URL = `${API_URL}/games/update-game-image`
export const BULK_UPLOAD_GAME_IMAGE_API_URL = `${API_URL}/games/bulk-upload-image`


/*SUBMIT GAME UPLOAD FILE API Endpoint*/
export const SUBMIT_GAME_UPLOAD_API = `${API_URL}/games/game-upload`;
export const SUBMIT_GAME_BULK_UPLOAD_JSON_API = `${API_URL}/games/game-bulk-upload`;

export const GET_TEMP_GAME_UPLOAD_QUEUE = `${API_URL}/games/games-in-queue`;

export const FINAL_SUBMIT_GAME_UPLOAD_API = `${API_URL}/games/game-upload-final`;
/*SUBMIT GAME UPLOAD FILE API Endpoint*/

export const TOGGLE_TOP_GAME_API = `${API_URL}/games/toggle-top-game`;
export const GET_TOP_GAME_LIST_API = `${API_URL}/games/top-game-list`;
export const UPDATE_TOP_GAME_RANK_API = `${API_URL}/games/update-top-game-rank`;

/*All Game List API endpoints */

/*All Provider API endpoints */
export const GET_ALL_MAIN_PROVIDER_LIST = `${API_URL}/provider/provider-details-list`;

export const TOGGLE_PROVIDER_LIST_STATUS = `${API_URL}/provider/provider-status-toggle`;

// export const TOGGLE_SUBPROVIDER_LIST_STATUS = `${API_URL}/provider/sub-provider-status-toggle`;

export const PROVIDER_VIEW_DETAILS_API = `${API_URL}/provider/provider-details`;

export const PROVIDER_CURRENCY_DETAILS_API = `${API_URL}/account/list-currencies`;

export const PROVIDER_EDIT_DETAILS_API = `${API_URL}/provider/provider-edit-details`;

export const PROVIDER_ACCOUNT_DETAILS_API = `${API_URL}/provider/show-account`;

export const GET_ALL_PROVIDER_ACCOUNT_LIST = `${API_URL}/provider/account-list`;

export const ADD_PROVIDER_ACCOUNT_API = `${API_URL}/provider/provider-account-add`;

export const UPDATE_PROVIDER_CREDENTIALS_API = `${API_URL}/provider/provider-update-credentials`;

export const DELETE_PROVIDER_CREDENTIALS_API = `${API_URL}/provider/provider-delete-credentials`;

/*All Provider API endpoints */

//! Api End Point For Report Component

/* All LowerLebel Client Account  List API end points */
export const GET_LOWER_LEBEL_CLIENT_ACCOUNT_LIST = `${API_URL}/reports/list-account`;
/* All LowerLebel Client Account List API end points */

/* All Provider Report List API end points */
export const GET_ALL_PROVIDER_REPORT_LIST = `${API_URL}/reports/provider-report`;
/* All Provider Report List API end points */

/* All Category Report List API end points */
export const GET_ALL_CATEGORY_REPORT_LIST = `${API_URL}/reports/category-report`;
/* All Category  Report List API end points */

/* All Revenue  Report List API end points */
export const GET_ALL_REVENUE_REPORT_LIST = `${API_URL}/reports/revenue-report`;
/* All Revenue  Report List API end points */

/* All game Report List API end points */
export const GET_ALL_GAME_REPORT_LIST = `${API_URL}/reports/game-report`;

/* Provider Transction Report API end point */
export const GET_PROVIDER_TRANSCTION_REPORT_LIST = `${API_URL}/reports/provider-transaction-report`;

export const GET_ALL_WALLET_REPORT_LIST = `${API_URL}/wallet/get-wallet-report`;
//! Api End Point For Report Component

/* Egg Resale Price Update Api End Point */
export const EGG_RESALE_PRICE_UPDATE = `${API_URL}/admin/admin-setting-update`;
/* Egg Resale Price Update Api End Point */

//! Api End Point For Setting Component
/* Get Admin Seeting | currency */
export const GET_ADMIN_SEETING = `${API_URL}/admin/admin-setting`;
/* Get Admin Seeting | currency */

/* Add New Currency  Api End Point */
export const ADD_NEW_CURRENCY = `${API_URL}/admin/add-currency`;
/*Add New Currency Api End Point */
//! Api End Point For Setting Component

//! Api End Point For Wallet Component
/* get Admin Balance by Currency Wise Api End Point */
export const GET_WALLET_BALANCE = `${API_URL}/wallet/get-balance`;
/* get Admin Balance by Currency Wise Api End Point */

/* get Admin Balance log*/
export const GET_BALANCE_LOG = `${API_URL}/wallet/get-balance-log`;
/* get Admin Balance log */

/* deposite balance Api end point*/
export const DEPOSITE_BALANCE = `${API_URL}/wallet/deposit-balance`;
/* deposite balance Api end point*/
//! Api End Point For Wallet Component

//! Assign InActive Provider
export const ASSIGN_INACTIVE_PROVIDER = `${API_URL}/client/assign-inactive-provider`;
// export const GET_SUB_CLIENTLIST = `${API_URL}/client/get-subclient-list`;

// export const UPDATE_CLIENT_PROVIDER_MAPPING = `${API_URL}/client/update-client-provider-mapping`;

export const GET_ASSIGN_PROVIDER_LIST = `${API_URL}/client/get-assigned-provider`;

export const GET_CLIENT_WISE_CURRENCY = `${API_URL}/account/client-acount-link-currencies`;

export const GET_CURRENCY_WISE_ACCOUNT_PROVIDER = `${API_URL}/account/currency-account-providers`;

export const GET_CURRENCY_PROVIDER_WISE_SUB_PROVIDER = `${API_URL}/account/currency-sub-providers`;
export const GAME_SEARCH = `${API_URL}/account/game-search`;

export const ASSIGN_GAMES_TO_ACCOUNT = `${API_URL}/account/assign-game`;
//! Assign InActive Provider

// role management api
export const GET_ROLE_LIST = `${API_URL}/role-management/role-list`;
export const ADD_USER_ROLE = `${API_URL}/role-management/add-role`;
export const UPDATE_USER_ROLE = `${API_URL}/role-management/update-role-name`;
export const UPDATE_USER_ROLE_STATUS = `${API_URL}/role-management/role-status-toggle`;
export const GET_ROLE_DETAILS = `${API_URL}/role-management/role-details`;
export const UPDATE_ROLE_DETAILS = `${API_URL}/role-management/update-assigned-menus`;

// user management api
export const ADD_USER = `${API_URL}/user/add-user`;
export const GET_USER_LIST = `${API_URL}/user/user-list`;
export const USER_DETAILS = `${API_URL}/user/user-details`;
export const UPDATE_USER = `${API_URL}/user/update-user`;
export const UPDATE_USER_STATUS = `${API_URL}/user/update-user-status`;
export const USER_RESET_PASSWORD = `${API_URL}/user/change-password`;


//common routes
export const GET_ASSIGNED_GAMES_API_URL = `${API_URL}/common/get-assigned-games`;
export const CHANGE_GAME_STATUS_API_URL = `${API_URL}/common/change-game-status`;
//common routes

// Dashboard routes
export const DASHBOARD_DATA_API = `${API_URL}/dashboard/get-dashboard-summary`;
export const DASHBOARD_GRAPH_GAMEPLAY = `${API_URL}/dashboard/get-dashboard-summary-monthly`;
export const DASHBOARD_GRAPH_WALLET = `${API_URL}/dashboard/get-wallet-summary`;
export const RD_URL = `${API_URL}/common/get-round-url`;

export const DASHBOARD_CATEGORYWISE = `${API_URL}/dashboard/category-summary`;
export const DASHBOARD_TOPGAMES = `${API_URL}/dashboard/game-summary`;
export const DASHBOARD_PROVIDERWISE = `${API_URL}/dashboard/provider-summary`;
export const DASHBOARD_CLIENTWISE = `${API_URL}/dashboard/client-summary`;

export const PROVIER_BET_RANGE_INFO = `${API_URL}/admin/get-provider-bet-info`;
export const ADD_MASTER_BET_RANGE = `${API_URL}/admin/add-bet-range`;
export const GET_BET_RANGE = `${API_URL}/admin/get-bet-range`;
export const ASSIGN_BET_RANGE = `${API_URL}/admin/assign-bet-range`;
export const ASSIGN_ALL_PROVIDER_GAMES = `${API_URL}/common/assign-all-provider-games`;
export const GET_ASSIGN_SKIN = `${API_URL}/games/assign-skin`;
export const UPDATE_ASSIGN_SKIN = `${API_URL}/games/update-game-skin`;
export const GET_PROVIDER_API_LOG = `${API_URL}/admin/get-request-log`;
export const GET_RESPONSE_GRAPH = `${API_URL}/admin/get-recent-response-times`;
export const GET_CLIENT_API_LOG = `${API_URL}/admin/get-request-log`;
export const GET_EVO_SKIN_LIST = `${API_URL}/admin/get-evolution-skin-details`;
export const ADD_EVO_SKIN = `${API_URL}/admin/add-master-skin`;
export const GET_SKIN_DETAILS = `${API_URL}/admin/get-master-skin-details`;
export const UPDATE_SKIN_DETAILS = `${API_URL}/admin/update-master-skin`;
export const GET_EVO_SKIN_RANGE_LIST = `${API_URL}/admin/get-evo-bet-range`;
export const ASSIGN_EVO_SKINS = `${API_URL}/admin/assign-evo-skin`;
export const EVO_SKIN_STATUS_UPDATE = `${API_URL}/admin/update-skin-status`;

export const PROVIDER_CURRENCY_LIST = `${API_URL}/provider/provider-currency-list`;
export const PROVIDER_CATEGORY_LIST = `${API_URL}/provider/provider-category-list`;

export const getGlobalMaintenanceMode = `${API_URL}/admin/get-global-maintenance-mode`;
export const updateGlobalMaintenanceMode = `${API_URL}/admin/set-global-maintenance-mode`;

export const LAUNCH_GAME_FOR_PLAYER_URL = `${API_URL}/admin/launch-game-for-player`;

export const GET_ASSIGNED_FREE_SPIN_PROVIDER_ = `${API_URL}/common/get-assign-freespin-providers`;
export const SET_ASSIGNED_FREE_SPIN_PROVIDER_ = `${API_URL}/common/set-assign-freespin-providers`;

export const ALL_AND_ASSIGNED_PROVIDERS_BY_CLIENTID = `${API_URL}/client/all-and-assigned-providers-by-clientid`;
export const PROVIDER_DETAILS_UPDATE = `${API_URL}/provider/provider-update`;
export const PROVIDER_GENERAL_CREDENTIAL_UPDATE = `${API_URL}/provider/update-general-credentials`;
export const PROVIDER_TECHNICAL_CREDENTIAL_UPDATE = `${API_URL}/provider/update-technical-credentials`;
export const ADD_PROVIDER_ACCOUNT = `${API_URL}/provider/add-account`;
export const ADD_MAIN_PROVIDER = `${API_URL}/provider/add-provider`;

// Server should return AuthModel
export function login(username: string, password: string) {
	//console.log(LOGIN_URL);
	let body = {
		"username": username,
		"password": password
	}
	let hash = getPayloadHash(body);

	return axios.post<AuthModel>(LOGIN_URL, {
		username,
		password,
		hash
	});
}

//! Function for Client
/*Add operator Modal Submit Function*/
export function addNewClient(
	token: string | null,
	firstname: string,
	lastname: string,
	email: string,
	contact: string,
	username: string,
	password: string,
	environment: string
) {
	let body = {
		"firstname": firstname,
		"lastname": lastname,
		"email": email,
		"contact": contact,
		"username": username,
		"password": password,
		"environment": environment
	}
	let hash = getPayloadHash(body);

	return axios.post<AddOperatorModal>(
		ADD_NEW_CLIENT_FORM_SUBMIT,
		{
			firstname,
			lastname,
			email,
			contact,
			username,
			password,
			environment,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*Add operator Modal Submit Function*/

/*View get General  Account Function*/
export function getOperatorAccountGeneral(token: string | null, account_id: string) {
	let body = {
		"account_id": account_id
	}
	let hash = getPayloadHash(body);

	return axios.post(
		GET_OPERATOR_ACCOUNT_GENERAL,
		{
			account_id,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*View get General  Account Function*/

/*View update General  Account Function*/
export function updateAccountGeneral(token: string | null, account_id: string, account_name: string, maintainance_mode: boolean, standard_resale_price: number, threshold: number) {
	let body = {
		"account_id": account_id,
		"account_name": account_name,
		"maintainance_mode": maintainance_mode,
		"standard_resale_price": standard_resale_price,
		"threshold": threshold
	}
	let hash = getPayloadHash(body);

	return axios.post(
		UPDATE_ACCOUNT_GENERAL,
		{
			account_id,
			account_name,
			maintainance_mode,
			standard_resale_price,
			threshold,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*View update General  Account Function**/

/*View get General  Account Function*/
export function getOperatorAccountTechinical(token: string | null, account_id: string) {
	let body = {
		"account_id": account_id
	}
	let hash = getPayloadHash(body);

	return axios.post(
		GET_OPERATOR_ACCOUNT_TECHINICAL,
		{
			account_id,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*View get General  Account Function*/

/*View update General  Account Function*/
export function updateAccountTechinical(token: string | null, account_id: string, api_secret: string, service_endpoint: string, whitelisted_ip, evolution_service_endpoint: string, enable_evolution: boolean) {
	let body = {
		"account_id": account_id,
		"api_secret": api_secret,
		"service_endpoint": service_endpoint,
		"evolution_service_endpoint": evolution_service_endpoint,
		"whitelisted_ip": whitelisted_ip,
		"enable_evolution": enable_evolution
	}
	let hash = getPayloadHash(body);
	return axios.post(
		UPDATE_ACCOUNT_TECHINICAL,
		{
			account_id,
			api_secret,
			service_endpoint,
			evolution_service_endpoint,
			whitelisted_ip,
			enable_evolution,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

/*View update General  Account Function**/

/*View client account revenue setting Function*/
export function getClientAccountRevenueSeeting(token: string | null, account_id: string) {
	let body = {
		"account_id": account_id
	}
	let hash = getPayloadHash(body);
	return axios.post(
		GET_CLIENT_ACCOUNT_REVENUE_SETTING,
		{
			account_id,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*View client account revenue seeting  Function**/
export function updateClientAccountRevenueSeeting(token: string | null, account_id: string, provider_data: any) {
	let body = {
		"account_id": account_id,
		"provider_data": provider_data,
	}
	let hash = getPayloadHash(body);
	return axios.post(
		UPDATE_CLIENT_ACCOUNT_REVENUE_SEETING,
		{
			account_id,
			provider_data,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*View update General  Account Function**/
/*View assign provider account list Function*/
export function getAssignProviderAccountList(token: string | null, account_id: string) {
	let body = {
		"account_id": account_id,
	}
	let hash = getPayloadHash(body);
	return axios.post(
		GET_ASSIGN_PROVIDER_ACCOUNT_LIST,
		{
			account_id,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*View  assign provider account list  Function**/

/*View assign provider account Function*/
export function assignProviderToAccount(token: string | null, account_id: string, providers) {
	let body = {
		"account_id": account_id,
		"providers": providers,
	}
	let hash = getPayloadHash(body);
	return axios.post(
		ASSIGN_PROVIDER_ACCOUNT,
		{
			account_id,
			providers: providers,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*View assign provider account  Function**/
/*View  Account Balance For Client Function */
export function getClientAccountBalance(token: string | null, account_id: string) {
	let url = `${GET_CLIENT_ACCOUNT_BALANCE}?account_id=${account_id}`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

export function transferClientAccountBalance(token: string | null, account_id: string, amount) {
	let body = {
		"account_id": account_id,
		"amount": amount,
	}
	let hash = getPayloadHash(body);
	return axios.post(
		TRANSFER_CLIENT_ACCOUNT_BALANCE,
		{
			account_id,
			amount,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function deductClientAccountBalanceConfirmation(token: string | null, account_id: string, amount) {
	let body = {
		"account_id": account_id,
		"amount": amount,
	}
	let hash = getPayloadHash(body);
	return axios.post(
		DEDUCT_CLIENT_ACCOUNT_BALANCE,
		{
			account_id,
			amount,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function deductClientAccountBalance(token: string | null, account_id: string, amount: string, password: string) {
	let body = {
		"account_id": account_id,
		"amount": amount,
		"password": password
	}
	let hash = getPayloadHash(body);
	return axios.post(
		DEDUCT_CLIENT_ACCOUNT_BALANCE_CONFIRM,
		{
			account_id,
			amount,
			password,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}


/* View Account Balance For Client Function */

/*Delete Game Category Function*/
export function deleteGameCategory(token, categoryId) {
	let body = {
		"category_id": categoryId
	}
	let hash = getPayloadHash(body);
	return axios.post(
		DELETE_GAME_CATEGORY,
		{
			category_id: categoryId,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*Delete Game Category Function*/

/*Change Status Game Category Function*/
export function changeStatusGameCategory(token, categoryId) {
	let body = {
		"category_id": categoryId
	}
	let hash = getPayloadHash(body);
	return axios.post(
		CHANGE_STATUS_GAME_CATEGORY,
		{
			category_id: categoryId,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*Change Status Game Category Function*/

/*Load Edit Game Category Modal Form Fields Function*/
export function loadEditGameCategoryFormFields(token, categoryId) {
	let body = {
		"category_id": categoryId
	}
	let hash = getPayloadHash(body);
	return axios.post(
		GET_EDIT_GAME_CATEGORY_FORM_FIELDS,
		{
			category_id: categoryId,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*Load Edit Game Category Modal Form Fields Function*/

/*Submit Edit Game Category Modal Form Fields Function*/
export function submitEditGameCategoryFormFields(token: string | null, data: any) {
	let hash = getPayloadHash(data);
	data = {
		...data,
		hash
	}
	return axios.post(SUBMIT_EDIT_GAME_CATEGORY_FORM_FIELDS, data, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}
/*Submit Edit Game Category Modal Form Fields Function*/

/*Load Add Game Category Modal Form Fields Function*/
export function loadGameCategoryFormFields(token) {
	return axios.get(GET_ADD_GAME_CATEGORY_FORM_FIELDS, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}
/*Load Add Game Category Modal Form Fields Function*/

/*Add Category Modal Submit Function*/
export function addGameCategory(token: string | null, data: any) {

	data = {
		"category_name": data
	}

	let hash = getPayloadHash(data);
	data.hash = hash;

	return axios.post(
		ADD_GAME_CATEGORY_FORM_SUBMIT,
		data,
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*Add Category Modal Submit Function*/

/*Get Search List API*/
export function getSearchList(token: string, formdata: any, itemsPerPage, currentPage) {
	const url = `${GET_SEARCH_GAME_LIST}?page=${currentPage}&limit=${itemsPerPage}`;
	const searchFormData = {
		provider: formdata.provider,
		subProvider: formdata.subProvider,
		category: formdata.category,
		status: formdata.status,
		searchText: formdata.searchText,
		...(typeof formdata.rtp === "number"
			? { rtp: formdata.rtp }
			: {}),
		...(formdata.top_game !== undefined
			? { top_game: formdata.top_game }
			: {}),
	};
	let hash = getPayloadHash(searchFormData);

	return axios.post(
		url,
		{
			// provider: searchFormData.provider,
			// subProvider: searchFormData.subProvider,
			// category: searchFormData.category,
			// status: searchFormData.status,
			// searchText: searchFormData.searchText,
			// rtp: searchFormData.rtp,
			...searchFormData,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*Get Search List API*/

/*Toggle Top Game Function*/
export function toggleTopGame(token: string, game_id: string | string[], is_top?: boolean) {
	const idsArray = (Array.isArray(game_id) ? game_id : [game_id])
		.map((id) => (typeof id === "object" && id !== null ? (id as any)._id || (id as any).id || String(id) : String(id)))
		.filter(Boolean);

	const firstId = idsArray.length > 0 ? idsArray[0] : "";

	let body: any = {
		game_id: firstId,
		game_ids: idsArray,
	};
	if (is_top !== undefined) {
		body.is_top = is_top;
	}
	let hash = getPayloadHash(body);
	return axios.post(
		TOGGLE_TOP_GAME_API,
		{ ...body, hash },
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

/*Get Top Game List Function*/
export function getTopGameList(token: string, provider_id?: string, search?: string) {
	let body: any = {};
	if (provider_id) body.provider_id = provider_id;
	if (search) body.search = search;
	let hash = getPayloadHash(body);
	return axios.post(
		GET_TOP_GAME_LIST_API,
		{ ...body, hash },
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

/*Update Top Game Rank Function*/
export function updateTopGameRank(token: string, game_ids: string[]) {
	let body = { game_ids };
	let hash = getPayloadHash(body);
	return axios.post(
		UPDATE_TOP_GAME_RANK_API,
		{ ...body, hash },
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

/*Delete Game Category Function*/
export function deleteGameListItem(token, itemId) {
	let body = {
		"game_id": itemId
	}
	let hash = getPayloadHash(body);
	return axios.post(
		DELETE_GAME_LIST_ITEM,
		{
			game_id: itemId,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*Delete Game Category Function*/

export function deleteAllErrorGamesInQueue(token) {
	let hash = getPayloadHash({});
	return axios.post(
		DELETE_ALL_ERROR_GAMES,
		{ hash },
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

/*Change Status Game List Function*/
export function changeStatusGameList(token, itemId) {
	let body = {
		"game_id": itemId
	}
	let hash = getPayloadHash(body);
	//console.log(itemId, "item id");
	return axios.post(
		CHANGE_STATUS_GAME_LIST,
		{
			game_id: itemId,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*Change Status Game Category Function*/

/*Load GAME MODIFY FORM DATA Function*/
export function loadModifyGameFormFields(token: string, gameId: string) {
	//console.log(gameId, "game id");
	let body = {
		"game_id": gameId
	}
	let hash = getPayloadHash(body);
	return axios.post(
		MODIFY_GAME_DATA_FORM_LOAD_API,
		{
			game_id: gameId,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*Load GAME MODIFY FORM DATA Function*/

export function submitModifyGameList(token: string | null, data: any, gameCode: string, gameCodeValidationIgnore: boolean) {
	const url = `${MODIFY_GAME_DATA_FORM_SUBMIT_API}?game_id=${gameCode}&validation_ignore=${gameCodeValidationIgnore}`;
	let hash = getPayloadHash(data);
	return axios.post(
		url,
		{
			...data,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function updateGameImage(token: string | null, formData: any) {
	//console.log("formData===>", formData)

	// Extract file
	const { image, ...rest } = formData;

	// Build form-data
	const fd = new FormData();

	// Append file if exists
	if (image) {
		fd.append("image", image);
	}
	// Append other fields
	Object.entries(rest).forEach(([key, value]) => {
		fd.append(key, value as any);
	});
	let hash = getPayloadHash(rest);
	fd.append("hash", hash);
	return axios.post(
		UPDATE_GAME_IMAGE_API_URL, fd,
		{
			headers: {
				token: `${token}`,
			},
		}
	)
}
export function bulkUploadGameImage(token: string | null, formData: any) {
	const { image, ...rest } = formData;
	const fd = new FormData();
	if (image) {
		fd.append("image", image);
	}
	Object.entries(rest).forEach(([key, value]) => {
		fd.append(key, value as any);
	});
	let hash = getPayloadHash(rest);
	fd.append("hash", hash);
	return axios.post(
		BULK_UPLOAD_GAME_IMAGE_API_URL, fd,
		{
			headers: {
				token: `${token}`,
			},
		}
	)
}

/*Search Client / User API Call*/
export function searchUserClient(search: string, type: string, token: string | null) {
	let body = {
		"search": search,
		"type": type
	}
	let hash = getPayloadHash(body);
	return axios.post(
		SEARCH_USER_CLIENT,
		{
			search: search,
			type: type,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function navigateToAllClientList(client_id: string, token: string | null) {
	let body = {
		"client_id": client_id
	}
	let hash = getPayloadHash(body);
	return axios.post(
		NAVIGATE_ALL_CLIENT_LIST,
		{
			client_id,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*Search Client / User API Call*/

/*All Provider List Axios Functions */
export function getAllMainProviderList(token: string | null, itemsPerPage: string | number | null | undefined, currentPage: string | number | null | undefined) {
	const url = `${GET_ALL_MAIN_PROVIDER_LIST}?page=${currentPage}&limit=${itemsPerPage}`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

export function toggleAllMainProviderListStatus(token: string, provider_id: string | null | undefined, status: string | null | undefined) {
	let body = {
		"provider_id": provider_id,
		"status": status
	}
	let hash = getPayloadHash(body);
	return axios.post(
		TOGGLE_PROVIDER_LIST_STATUS,
		{
			provider_id: provider_id,
			status,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

/*Get LowerLebel Client Account List API*/
export function getLowerLebelClientAccountList(token: string, clientID: string | null) {
	const url = `${GET_LOWER_LEBEL_CLIENT_ACCOUNT_LIST}?client_id=${clientID}`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}
/*Get LowerLebel Client Account API*/

/*Get All Provider Wise Reports API*/
export function getAllProviderReportList(token: string, clientId: string, accountId: string, start: string, end: string, recursive: any, currency: string) {
	const url = `${GET_ALL_PROVIDER_REPORT_LIST}?client_id=${clientId}&account_id=${accountId}&start_date=${start}&end_date=${end}&recursive=${recursive}&currency=${currency}`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}
/*Get All Provider Wise  Reports  API*/

/*Get All Provider Wise Reports API*/
export function getAllCategoryReportList(token: string, clientId: string, accountId: string, start: string, end: string, recursive: boolean, currency: string) {
	const url = `${GET_ALL_CATEGORY_REPORT_LIST}?client_id=${clientId}&account_id=${accountId}&start_date=${start}&end_date=${end}&recursive=${recursive}&currency=${currency}`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}
/*Get All Provider Wise  Reports  API*/

/*Get All Revenue Wise Reports API*/
export function getAllRevenueReportList(token: string, clientId: string, accountId: string, start: string, end: string) {
	const url = `${GET_ALL_REVENUE_REPORT_LIST}?account_id=${accountId}&start_date=${start}&end_date=${end}`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}
/*Get All Revenue Wise  Reports  API*/

/*Get All Game Wise Reports API*/
export function getAllGameReportList(token: string, clientId: string, accountId: string, start: string, end: string, providerId: string, categoryId: string, recursive: boolean, currency: string) {
	const url = `${GET_ALL_GAME_REPORT_LIST}?client_id=${clientId}&account_id=${accountId}&start_date=${start}&end_date=${end}&provider_id=${providerId}&category_id=${categoryId}&recursive=${recursive}&currency=${currency}`;
	//console.log(url, "url");
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}
/*Get All Game Wise  Reports  API*/

/*Get Provider transction Reports API*/
export function getProviderTransctionReport(token: string, clientId: string, accountId: string, start: string, end: string, providerId: string, recursive: any, currency: string) {
	const url = `${GET_PROVIDER_TRANSCTION_REPORT_LIST}?client_id=${clientId}&account_id=${accountId}&start_date=${start}&end_date=${end}&provider_id=${providerId}&recursive=${recursive}&currency=${currency}`;
	//console.log(url, "url");
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

/*Get All Wallet Wise Reports API*/
export function getAllWalletReportList(token: string, clientId: string | null, accountId: string | null, lowerClientId: string | null, lowerAccountId: string | null, start: string, end: string, currency, type, transactionType, walletType, page, limit) {
	// const url = `${GET_ALL_REVENUE_REPORT_LIST}?account_id=${accountId}&start_date=${start}&end_date=${end}`;
	let body: any = {
		to_client_id: lowerClientId,
		to_account_id: lowerAccountId,
		type: type,
		date_from: start,
		date_to: end,
		from_client_id: clientId,
		from_account_id: accountId,
		currency: currency,
		transaction_type: transactionType,
		page: page,
		limit: limit
	}
	// wallet_type is optional — only send when a specific type is selected
	if (walletType && walletType !== "all") {
		body.wallet_type = walletType;
	}
	let hash = getPayloadHash(body)
	let postBody: any = {
		to_client_id: lowerClientId,
		to_account_id: lowerAccountId,
		type: type,
		date_from: start,
		date_to: end,
		from_client_id: clientId,
		from_account_id: accountId,
		currency: currency,
		transaction_type: transactionType,
		page: page,
		limit: limit,
		hash
	}
	if (walletType && walletType !== "all") {
		postBody.wallet_type = walletType;
	}
	return axios.post(
		GET_ALL_WALLET_REPORT_LIST,
		postBody,
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*Get All Wallet Wise  Reports  API*/
//! Function for report

/*All Game Upload Axios Function */
export function getAllGameUploadList(token: string | null, itemsPerPage: string | number | null | undefined, currentPage: string | number | null | undefined) {
	// const url = `${GET_TEMP_GAME_UPLOAD_QUEUE}?page=${currentPage}&limit=${itemsPerPage}`;
	const url = `${GET_TEMP_GAME_UPLOAD_QUEUE}`;
	let body = {
		limit: itemsPerPage,
		page: currentPage,
		provider_id: '',
		category_id: '',
	}
	let hash = getPayloadHash(body)
	return axios.post(
		url,
		{
			limit: itemsPerPage,
			page: currentPage,
			provider_id: '',
			category_id: '',
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function submitGameUploadFile(token: string | null, file: any, formData: any) {
	let formDataUpdated = new FormData();
	formDataUpdated.append("file", file);
	formDataUpdated.append("game_provider_id", formData.provider);
	formDataUpdated.append("sub_provider", formData.subProvider);
	let hash = getPayloadHash(formDataUpdated)
	formDataUpdated.append("hash", hash)
	return axios.post(SUBMIT_GAME_UPLOAD_API, formDataUpdated, {
		headers: {
			"Content-Type": "multipart/form-data",
			token: `${token}`,
		},
	});
}

export function submitGameBulkUploadJSON(token: string, payload: any, upload_sd2: boolean = true, upload_sd3: boolean = true) {
	let body = { games: payload, upload_sd2, upload_sd3 };
	let hash = getPayloadHash(body);
	return axios.post(SUBMIT_GAME_BULK_UPLOAD_JSON_API, { games: payload, upload_sd2, upload_sd3, hash }, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		}
	});
}

export function finalSubmitGameUpload(token: string, selectedItems: any) {
	let body = {
		"game_Ids": selectedItems
	}
	let hash = getPayloadHash(body)
	return axios.post(
		FINAL_SUBMIT_GAME_UPLOAD_API,
		{
			game_Ids: selectedItems,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function providerViewDetails(token: string, id: string) {
	let body = {
		provider_id: id,
	}
	let hash = getPayloadHash(body)
	return axios.post(
		PROVIDER_VIEW_DETAILS_API,
		{
			provider_id: id,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function providerCurrencyDetails(token: string) {
	return axios.get(PROVIDER_CURRENCY_DETAILS_API, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}
// export function providerEditDetails(token: string, id: string) {
// 	return axios.post(
// 		PROVIDER_EDIT_DETAILS_API,
// 		{ id },
// 		{
// 			headers: {
// 				"Content-Type": "application/json",
// 				token: `${token}`,
// 			},
// 		}
// 	);
// }
export function providerAccountList(token: string, limit: number | string, page: number | string, provider_id: string) {
	let body = { provider_id: provider_id }
	let hash = getPayloadHash(body)
	return axios.post(
		`${GET_ALL_PROVIDER_ACCOUNT_LIST}?limit=${limit}&page=${page}`,
		{
			provider_id: provider_id,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function providerAccountDetails(token: string, body: any) {

	let hash = getPayloadHash(body)
	return axios.post(
		PROVIDER_ACCOUNT_DETAILS_API,
		{
			...body,
			hash: hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function updateProviderCredentials(token: string) {
	return axios.post(UPDATE_PROVIDER_CREDENTIALS_API, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}
export function deleteProviderCredentials(token: string) {
	return axios.post(DELETE_PROVIDER_CREDENTIALS_API, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

/*All Game Upload Axios Function */

//! Function for Setting Component
/* Get Admin Seeting function */
export function GetAdminSeeting(token: string | null) {
	return axios.get(GET_ADMIN_SEETING, { headers: { "Content-Type": "application/json", token: `${token}` } });
}
/* Get Admin Seeting Function */

/* Update Egg Resale Price function */
export function updateEggResalePrice(token: string, id: string, resalePrice) {
	let body = {
		id: id,
		default_egg_resale_price: resalePrice,
	}
	let hash = getPayloadHash(body)
	return axios.post(
		EGG_RESALE_PRICE_UPDATE,
		{
			id: id,
			default_egg_resale_price: resalePrice,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/* Update Egg Resale Price function */

/* Add new Currency Schema */
export function addNewCurrency(token: string, currencyCode) {
	let body = {
		currency_code: currencyCode,
	}
	let hash = getPayloadHash(body)
	return axios.post(
		ADD_NEW_CURRENCY,
		{
			currency_code: currencyCode,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/* Add new Currency Schema */
//! Function for Setting Component

//! Function for Wallet
/* Get Wallet Balance Function */
export function getWalletBalance(token: string | null, CurrencyCode) {
	const url = `${GET_WALLET_BALANCE}?currency=${CurrencyCode}`;
	return axios.get(url, { headers: { "Content-Type": "application/json", token: `${token}` } });
}
/* Get Wallet Balance Function */
/* Get Wallet Balance Function */
export function getBalanceLog(token: string | null, CurrencyCode, page, limit) {
	const url = `${GET_BALANCE_LOG}?currency=${CurrencyCode}&page=${page}&limit=${limit}`;
	return axios.get(url, { headers: { "Content-Type": "application/json", token: `${token}` } });
}
/* Get Wallet Balance Function */
/* Deposite balance Function */
export function depositeBalance(token: string | null, currency: string, amount: string, note: string) {
	let body = {
		currency_code: currency,
		amount: amount,
		comment: note,
	}
	let hash = getPayloadHash(body)
	return axios.post(
		DEPOSITE_BALANCE,
		{
			currency_code: currency,
			amount: amount,
			comment: note,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/* Deposite balance Function */
//! Function for Wallet

//! Function for assign provider to client or assign provider to games

export function getAssignProviderToClient(token: string | null) {
	return axios.get(ASSIGN_INACTIVE_PROVIDER, { headers: { "Content-Type": "application/json", token: `${token}` } });
}


export function getAssignProviderList(token: string | null, clientID: string) {
	let url = `${GET_ASSIGN_PROVIDER_LIST}?client_id=${clientID}`;
	return axios.get(url, { headers: { "Content-Type": "application/json", token: `${token}` } });
}

export function getClientWiseCurrencyList(token: string | null, clientID: string) {
	let url = `${GET_CLIENT_WISE_CURRENCY}?client_id=${clientID}`;
	return axios.get(url, { headers: { "Content-Type": "application/json", token: `${token}` } });
}

export function getCurrencyWiseAccountProvider(token: string | null, clientID: string, currency: string) {
	let url = `${GET_CURRENCY_WISE_ACCOUNT_PROVIDER}?client_id=${clientID}&currency=${currency}`;
	return axios.get(url, { headers: { "Content-Type": "application/json", token: `${token}` } });
}

export function getCurrencyProviderWiseSubProvider(token: string | null, providerId: string, currency: string) {
	let url = `${GET_CURRENCY_PROVIDER_WISE_SUB_PROVIDER}?provider_id=${providerId}&currency=${currency}`;
	return axios.get(url, { headers: { "Content-Type": "application/json", token: `${token}` } });
}

export function gameSearch(token: string | null, providerId: string, subProviderId: string, categoryId: string, currency: string) {
	let url = `${GAME_SEARCH}?provider_id=${providerId}&sub_provider_id=${subProviderId}&category_id=${categoryId}&currency=${currency}`;
	return axios.get(url, { headers: { "Content-Type": "application/json", token: `${token}` } });
}

export function assignGamesToAccount(token: string | null, accounts: string[], games: any,) {
	let body = {
		accounts: accounts,
		games: games,
	}
	let hash = getPayloadHash(body)
	return axios.post(
		CHANGE_GAME_STATUS_API_URL,
		{
			accounts: accounts,
			games: games,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export const ELIGIBLE_CLIENTS_ACCOUNTS_URL = `${API_URL}/account/eligible-clients-accounts`;
export const PROVIDER_GAMES_URL = `${API_URL}/account/provider-games`;
export const ASSIGN_GAMES_BULK_URL = `${API_URL}/account/assign-games-bulk`;

export function getEligibleClientsAccounts(token: string | null, providerId: string, search: string = "", page: number = 1, limit: number = 50) {
	let url = `${ELIGIBLE_CLIENTS_ACCOUNTS_URL}?provider_id=${providerId}&search=${encodeURIComponent(search)}&page=${page}&limit=${limit}`;
	return axios.get(url, { headers: { "Content-Type": "application/json", token: `${token}` } });
}

export function getProviderGames(token: string | null, providerId: string, categoryId: string = "", search: string = "", page: number = 1, limit: number = 50) {
	let url = `${PROVIDER_GAMES_URL}?provider_id=${providerId}&category_id=${categoryId}&search=${encodeURIComponent(search)}&page=${page}&limit=${limit}`;
	return axios.get(url, { headers: { "Content-Type": "application/json", token: `${token}` } });
}

export function assignGamesBulk(token: string | null, providerId: string, games: string[], accounts: string[], status: string) {
	let body = {
		provider_id: providerId,
		games: games,
		accounts: accounts,
		status: status
	};
	let hash = getPayloadHash(body);
	return axios.post(
		ASSIGN_GAMES_BULK_URL,
		{
			provider_id: providerId,
			games: games,
			accounts: accounts,
			status: status,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}


//! Function for player
export function register(email: string, firstname: string, lastname: string, password: string, password_confirmation: string) {
	let body = {
		email: email,
		first_name: firstname,
		last_name: lastname,
		password: password,
		password_confirmation: password_confirmation,
	}
	let hash = getPayloadHash(body)
	return axios.post(REGISTER_URL, {
		email,
		first_name: firstname,
		last_name: lastname,
		password,
		password_confirmation,
		hash
	});
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
	let body = {
		email: email
	}
	let hash = getPayloadHash(body)
	return axios.post<{ result: boolean }>(REQUEST_PASSWORD_URL, {
		email,
		hash
	});
}

export function getUserByToken(token: string) {
	let body = {
		api_token: token
	}
	let hash = getPayloadHash(body)
	return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
		api_token: token,
		hash
	});
}

export function getUserRoleList(token: string) {
	return axios.get(
		GET_ROLE_LIST,
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function addUserRole(token: string, role_name: string) {
	let body = {
		role_name: role_name
	}
	let hash = getPayloadHash(body)
	return axios.post(
		ADD_USER_ROLE,
		{
			role_name: role_name,
			hash
			// assign_menu: []
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function updateUserRoleStatus(token: string, role_id: string, status: string) {
	let body = {
		role_id: role_id
	}
	let hash = getPayloadHash(body)
	return axios.post(
		UPDATE_USER_ROLE_STATUS,
		{
			role_id: role_id,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function updateUserRole(token: string, role_name: string, role_id: string) {
	let body = {
		role_id: role_id,
		role_name: role_name
	}
	let hash = getPayloadHash(body)
	return axios.post(
		UPDATE_USER_ROLE,
		{
			role_id: role_id,
			role_name: role_name,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function getUserRoleDetails(token: string, role_id: string) {
	let body = {
		role_id: role_id
	}
	let hash = getPayloadHash(body)
	return axios.post(
		GET_ROLE_DETAILS,
		{
			role_id: role_id,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function updateUserRoleDetails(token: string, role_id: string, assigned_menu: object[]) {
	let body = {
		role_id: role_id,
		assigned_menu: assigned_menu
	}
	let hash = getPayloadHash(body)
	return axios.post(
		UPDATE_ROLE_DETAILS,
		{
			role_id: role_id,
			assigned_menu: assigned_menu,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

// user route function
export function getUserList(token: string, status: string) {
	return axios.get(
		`${GET_USER_LIST}?status=${status}`,
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function updateUserStatus(token: string, user_id: string, status: string) {
	let body = {
		user_id: user_id,
		status: status
	}
	let hash = getPayloadHash(body)
	return axios.post(
		UPDATE_USER_STATUS,
		{
			user_id: user_id,
			status: status,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function addUser(token: string, admin_name: string, role_id: string, contact: string, email: string, username: string, password: string) {
	let body = {
		admin_name: admin_name,
		role_id: role_id,
		contact: contact,
		email: email,
		username: username,
		password: password
	}
	let hash = getPayloadHash(body)
	return axios.post(
		ADD_USER,
		{
			admin_name: admin_name,
			role_id: role_id,
			contact: contact,
			email: email,
			username: username,
			password: password,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function updateUser(token: string, admin_name: string, contact: string, email: string, username: string, selectedUserId: string) {
	let body = {
		admin_name: admin_name,
		contact: contact,
		email: email,
		username: username,
		user_id: selectedUserId
	}
	let hash = getPayloadHash(body)
	return axios.post(
		UPDATE_USER,
		{
			admin_name: admin_name,
			contact: contact,
			email: email,
			username: username,
			user_id: selectedUserId,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function userResetPassword(token: string, password: string, user_id: string) {
	let body = {
		password: password,
		user_id: user_id
	}
	let hash = getPayloadHash(body)
	return axios.post(USER_RESET_PASSWORD,
		{
			password: password,
			user_id: user_id,
			hash
		}
		, {
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function getUserDetails(token: string, user_id: string) {
	return axios.get(
		`${USER_DETAILS}?user_id=${user_id}`,
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}



//common route function

export function getAssignedGames(token: string, formData) {
	let body = {
		account_id: formData.account_id,
		provider_id: formData.provider_id,
		status: formData.status,
		search_text: formData.search_text,
		category_id: formData.category_id,
		release_date: formData.release_date,
		assign_from: formData.assign_from,
		assign_to: formData.assign_to
	}
	let hash = getPayloadHash(body)
	return axios.post(
		GET_ASSIGNED_GAMES_API_URL,
		{
			account_id: formData.account_id,
			provider_id: formData.provider_id,
			status: formData.status,
			search_text: formData.search_text,
			category_id: formData.category_id,
			release_date: formData.release_date,
			assign_from: formData.assign_from,
			assign_to: formData.assign_to,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
};

export function changeGameStatus(token: string, account_id: string, gameId: string, status: string) {
	let body = {
		accounts: [account_id],
		games: [
			{
				game_id: gameId,
				status: status,
			}
		]
	}
	let hash = getPayloadHash(body)
	return axios.post(
		CHANGE_GAME_STATUS_API_URL,
		{
			accounts: [account_id],
			games: [
				{
					game_id: gameId,
					status: status,
				}
			],
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
};

export function changeGameStatusBulk(token: string, account_id: string, data) {
	let body = {
		accounts: [account_id],
		games: data
	}
	let hash = getPayloadHash(body)
	return axios.post(
		CHANGE_GAME_STATUS_API_URL,
		{
			accounts: [account_id],
			games: data,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
};
/** ================== CLIENT MANAGEMENT API ENDPOINTS ======================= */
/*Get Client List API Endpoint*/
export const GET_ALL_CLIENT_LIST_API_URL = `${API_URL}/client/all_client`;
/*Get Client List API Endpoint*/

/*Get Single Client API Endpoint*/
export const GET_CLIENT_API_URL = `${API_URL}/client/get_client`;
/*Get Single  Client API Endpoint*/

/* Edit A Single Client API Endpoint */
export const EDIT_CLIENT_API_URL = `${API_URL}/client/edit_client`;
/* Edit A Single Client API Endpoint  */

/* Edit Password Client API Endpoint */
export const EDIT_PASSWORD_CLIENT_API_URL = `${API_URL}/client/edit_password_client`;
/*  Edit Password Client API Endpoint */

/*Get Account Currency API Endpoint*/
export const GET_ACCOUNT_CURRENCY_API_URL = `${API_URL}/account/list-currencies`;
/*Get Account Currency API Endpoint*/

/* Add new operator account */
export const ADD_NEW_OPERATOR_ACCOUNT_API_URL = `${API_URL}/account/add-account`;
/* Add new operator account */

export const ASSIGN_PROVIDER_LIST_API_URL = `${API_URL}/client/assigned-provider`;
export const GET_ACCOUNT_TRANSACTIONS_API_URL = `${API_URL}/account/account-transactions`;
export const GET_GAME_PLAY_TRANSACTIONS_API_URL = `${API_URL}/account/game-play-transactions`;
export const CHANGE_ACCOUNT_STATUS_API_URL = `${API_URL}/account/account-status-change`;
export const SEARCH_USER_WITH_USERNAME_API_URL = `${API_URL}/search-player`;
/** ================== CLIENT MANAGEMENT API ENDPOINTS ======================= */

/** ================== CLIENT MANAGEMENT API FUNCTIONS ======================= */

export function getAccountTransactions(token, account_id, from_date, to_date, transaction_type, log_type, page, limit) {
	let url = `${GET_ACCOUNT_TRANSACTIONS_API_URL}?page=${page}&limit=${limit}`;
	let body = {
		account_id: account_id,
		from_date: from_date,
		to_date: to_date,
		transaction_type: transaction_type,
		log_type: log_type
	}
	let hash = getPayloadHash(body)
	return axios.post(
		url,
		{
			account_id,
			from_date,
			to_date,
			transaction_type,
			log_type,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	)
};

export function searchUserByUsername(search: string, user_id: string, token: string | null) {
	return axios.get(
		`${SEARCH_USER_WITH_USERNAME_API_URL}?search_value=${search}&id=${user_id}`,
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
};

export function getgamePlayTransactions(token, account_id, from_date, to_date, transaction_type, page, limit) {
	let url = `${GET_GAME_PLAY_TRANSACTIONS_API_URL}?page=${page}&limit=${limit}`;
	let body = {
		account_id: account_id,
		from_date: from_date,
		to_date: to_date,
		transaction_type: transaction_type,
	}
	let hash = getPayloadHash(body)
	return axios.post(
		url,
		{
			account_id,
			from_date,
			to_date,
			transaction_type,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	)
};

/*View All Client List Function*/
export function getAllClientListData(token: string | null, itemsPerPage: string | number, currentPage: string | number, clientId: string | null | undefined) {
	const url = `${GET_ALL_CLIENT_LIST_API_URL}?page=${currentPage}&limit=${itemsPerPage}`;

	let hash;
	if (clientId !== undefined) {
		let body = {
			parent_client_id: clientId
		}
		hash = getPayloadHash(body)
	}
	return axios.post(
		url,
		{
			parent_client_id: clientId,
			hash: hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*View All  Client List Function*/

/*View Single Client Function*/
export function getClientData(token: string | null, clientId: string | undefined | null) {
	const url = `${GET_CLIENT_API_URL}/${clientId}`;
	return axios.get<getClientDataModal>(
		url,

		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*View Single Client  Function*/

export function changeAccountStatus(token: string, account_id: string, status: string) {
	let body = {
		account_id: account_id,
		status: status
	}
	let hash = getPayloadHash(body)
	return axios.post(
		CHANGE_ACCOUNT_STATUS_API_URL,
		{
			account_id,
			status,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
};



/*View Edit Client Password Function */
export function UpdateClientPassword(token: string | null, new_password: string, id: string, superadmin_password: string) {
	let body = {
		id: id,
		superadmin_password: superadmin_password,
		new_password: new_password,
	}
	let hash = getPayloadHash(body)
	return axios.post<updateClientPasswordDataModal>(
		EDIT_PASSWORD_CLIENT_API_URL,
		{
			id,
			superadmin_password,
			new_password,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*View Edit Client Password Function */

/*View Account Currency List Function*/
export function getAccountCurrency(token: string | null) {
	return axios.get(GET_ACCOUNT_CURRENCY_API_URL, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}
/*View Account Currency Function*/

/*View add new Operator Account Function */
export function addOperatorAccount(token: string | null, client_id: string, account_name: string, currency: string) {
	let body = {
		client_id: client_id,
		account_name: account_name,
		currency: currency,
	}
	let hash = getPayloadHash(body)
	return axios.post(
		ADD_NEW_OPERATOR_ACCOUNT_API_URL,
		{
			client_id,
			account_name,
			currency,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/*View add new Operator Account Function */

export function assignProvider(token: string | null, client_id) {
	return axios.get(ASSIGN_PROVIDER_LIST_API_URL, {
		params: {
			client_id
		},
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

/*View Edit  Client Function*/
export function EditClientData(token: string | null, id: string, firstname: string, lastname: string, username: string, email: string, contact: string, branding: boolean, brand_theme: string, brand_image_light: string, brand_image_dark: string) {
	let body = {
		id: id,
		firstname: firstname,
		lastname: lastname,
		email: email,
		contact: contact,
		username: username,
		light: brand_image_light,
		dark: brand_image_dark,
		branding: branding,
		brand_theme: brand_theme
	}
	let hash = getPayloadHash(body)
	return axios.post<updateClientDataModal>(
		EDIT_CLIENT_API_URL,
		{
			id,
			firstname,
			lastname,
			email,
			contact,
			username,
			light: brand_image_light,
			dark: brand_image_dark,
			branding,
			brand_theme,
			hash
		},
		{
			headers: {
				"Content-Type": "multipart/form-data",
				token: `${token}`,
			},
		}
	);
}
/*View Edit Client  Function*/
/**Assign Provider Function */
export function updateAssignProviderMapping(client: string[], provider: any, token: string | null) {
	let body = {
		client_ids: client,
		provider_ids: provider,
	}
	let hash = getPayloadHash(body)
	return axios.post(
		UPDATE_ASSIGN_PROVIDER_MAPPING,
		{
			client_ids: client,
			provider_ids: provider,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
/**Assign Provider Function */
/** ================== CLIENT MANAGEMENT API FUNCTIONS ======================= */

/** ================== COMMON API ENDPOINTS AND FUNCTIONS ======================= */

export const CATEGORY_LIST_API_URL = `${API_URL}/common/category-list`;
export const ACCOUNT_LIST_API_URL = `${API_URL}/common/accounts-list`;
export const PROVIDER_LIST_API_URL = `${API_URL}/common/provider-list`;
export const MERGED_PROVIDER_LIST_API_URL = `${API_URL}/common/merged-provider-list`;
export const PLAYER_LIST_API_URL = `${API_URL}/common/players-list`;
export const GET_PLAYER_DETAILS_WITH_TRANSACTION_LOG_API_URL = `${API_URL}/common/player-detail-with-transaction-log`
export const SUSPICIOUS_ACTIVITY_LIST_API_URL = `${API_URL}/players/suspicious-activity-list`;
export const CLIENT_LIST_API_URL = `${API_URL}/common/clients-list`;
export const UPDATE_ASSIGN_PROVIDER_MAPPING = `${API_URL}/common/update-client-provider-mapping`;

/** ============================== CLIENT API ================================== */
export const ADD_NEW_CLIENT_API_FORM_SUBMIT = `${API_URL}/client-api/add-client-api`;
export const UPDATE_CLIENT_API_FORM_SUBMIT = `${API_URL}/client-api/update-client-api`;
export const CLIENT_API_LIST = `${API_URL}/client-api/client-api-list`;
export const UPDATE_CLIENT_API_STATUS = `${API_URL}/client-api/update-client-api-status`;
//export const DELETE_CLIENT_API = `${API_URL}/client-api/delete-client-api`;
/** ============================== TEST CASE ================================== */
export const TEST_CASE_LIST = `${API_URL}/test-case/all-test-case`;
export const UPDATE_TEST_CASE_STATUS = `${API_URL}/test-case/update-test-case-status`;
export const ADD_NEW_TEST_CASE_FORM_SUBMIT = `${API_URL}/test-case/add-test-case`;
export const UPDATE_TEST_CASE_FORM_SUBMIT = `${API_URL}/test-case/update-test-case`;
//export const DELETE_TEST_CASE = `${API_URL}/test-case/delete-test-case`;
export const TEST_CASE_REPORT = `${API_URL}/test-case/get-test-case-result`;
export function getCategoryList(token: string | null, provider_id, page, limit) {
	let body = {
		provider_id: provider_id,
		page: page,
		limit: limit
	}
	let hash = getPayloadHash(body)
	return axios.post(
		CATEGORY_LIST_API_URL,
		{
			provider_id,
			page,
			limit,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	)
}
export function getAccountList(token: string, clientId: string, currency: string, status: string, currentPage: number, itemsPerPage: number) {
	let body = {
		client_id: clientId,
		currency: currency,
		status: status,
		page: currentPage,
		limit: itemsPerPage
	}
	let hash = getPayloadHash(body)
	return axios.post(
		ACCOUNT_LIST_API_URL,
		{
			client_id: clientId,
			currency: currency,
			status: status,
			page: currentPage,
			limit: itemsPerPage,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
export function getProviderList(token: string | null, account_id, provider_id, page, limit, status = 'active') {
	const url = `${PROVIDER_LIST_API_URL}?page=${page}&limit=${limit}`;
	let body = {
		account_id: account_id,
		provider_id: provider_id,
		status: status
	}
	let hash = getPayloadHash(body)
	return axios.post(
		url,
		{
			account_id,
			provider_id,
			status,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	)
}
export function getMergedProviderList(token: string | null) {
	let body = {};
	let hash = getPayloadHash(body);
	return axios.post(
		MERGED_PROVIDER_LIST_API_URL,
		{ hash },
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}
export function getPlayerList(token: string | null, account_id: string, itemsPerPage: number, currentPage: number, date_from: string, date_to: string, status: string, user: string) {
	let body = {
		account_id: account_id,
		search_value: user,
		start_date: date_from,
		end_date: date_to,
		status: status,
		page: currentPage,
		limit: itemsPerPage
	}
	let hash = getPayloadHash(body)
	return axios.post(
		PLAYER_LIST_API_URL,
		{
			account_id: account_id,
			search_value: user,
			start_date: date_from,
			end_date: date_to,
			status: status,
			page: currentPage,
			limit: itemsPerPage,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export const getSuspiciousActivityList = async (filterParams: any, token: string | null) => {
  const body = {
    account_id: filterParams?.account_id || "",
    client_id: filterParams?.client_id || "",
    user_id: filterParams?.user_id || "",
    is_blocked: filterParams?.is_blocked !== undefined ? filterParams?.is_blocked : "all",
    start_date: filterParams?.start_date || "",
    end_date: filterParams?.end_date || "",
    page: filterParams?.page || 1,
    limit: filterParams?.limit || 10
  };

  // Attach computed hash signature
  const payload = {
    ...body,
    hash: getPayloadHash(body)
  };

  const response = await axios.post(SUSPICIOUS_ACTIVITY_LIST_API_URL, payload, {
    headers: {
      token: token || "",
      'Content-Type': 'application/json'
    }
  });

  return response.data;
};

export function playerDetailsWithTxnLog(token: string | null, player_id, start_date_time, end_date_time, transaction_type, provider_id, category_id, page, limit) {
	let body = {
		player_id: player_id,
		start_date_time: start_date_time,
		end_date_time: end_date_time,
		transaction_type: transaction_type,
		provider_id: provider_id,
		category_id: category_id,
		page: page,
		limit: limit
	}
	let hash = getPayloadHash(body)
	return axios.post(
		GET_PLAYER_DETAILS_WITH_TRANSACTION_LOG_API_URL,
		{
			player_id,
			start_date_time,
			end_date_time,
			transaction_type,
			provider_id,
			category_id,
			page,
			limit,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	)
}
export function getClientList(token: string | null, client_id, nth) {
	let url = `${CLIENT_LIST_API_URL}?client_id=${client_id}&nth=${nth}`
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}
/** ================== COMMON API ENDPOINTS AND FUNCTIONS ======================= */

/** ================== CLIENT API =================== */

export function addNewClientApi(
	token: string | null,
	client_api_name: string,
	api_endpoint: string,
	method: string,
	api_payload: string,
	api_response: string,
	status: string,
	api_type: string
) {
	let body = {
		client_api_name: client_api_name,
		api_endpoint: api_endpoint,
		method: method,
		api_payload: api_payload,
		api_response: api_response,
		status: status,
		api_type: api_type
	}
	let hash = getPayloadHash(body)
	return axios.post(
		ADD_NEW_CLIENT_API_FORM_SUBMIT,
		{
			client_api_name,
			api_endpoint,
			method,
			api_payload,
			api_response,
			status,
			api_type,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function updateClientApi(
	client_api_id: string | any,
	token: string | null,
	client_api_name: string,
	api_endpoint: string,
	method: string,
	header: string,
	api_payload: string,
	api_response: string,
	status: string
) {
	let body = {
		client_api_name: client_api_name,
		api_endpoint: api_endpoint,
		method: method,
		header: header,
		api_payload: api_payload,
		api_response: api_response,
		status: status
	}
	let hash = getPayloadHash(body)
	return axios.post(
		`${UPDATE_CLIENT_API_FORM_SUBMIT}?client_api_id=${client_api_id}`,
		{
			client_api_name,
			api_endpoint,
			method,
			header,
			api_payload,
			api_response,
			status,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function getClientApiList(
	token: string | null,
	type: string | null,
	status: string | null
) {

	return axios.get(
		CLIENT_API_LIST + '?type=' + type + '&status=' + status,

		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function updateClientApiStatus(token: string | any, client_api_id: string | any, status: string | any) {
	let body = {
		client_api_id: client_api_id,
		status: status
	}
	let hash = getPayloadHash(body)
	return axios.post(
		UPDATE_CLIENT_API_STATUS,
		{
			client_api_id: client_api_id,
			status: status,
			hash

		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function deleteClientApi(token: string | any, client_api_id: string | any) {
	let body = {
		client_api_id: client_api_id,
		status: "delete"
	}
	let hash = getPayloadHash(body)
	return axios.post(
		UPDATE_CLIENT_API_STATUS,
		{
			client_api_id: client_api_id,
			status: body.status,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function getTestCaseList(
	token: string | null,
	type: string | null,
	status: string | null
) {
	return axios.get(
		TEST_CASE_LIST + '?type=' + type + '&status=' + status,

		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function updateTestCaseStatus(token: string | any, test_case_id: string | any, status: string | any, testCaseType: string | any) {
	let body = {
		test_case_id: test_case_id,
		status: status,
		type: testCaseType
	}
	let hash = getPayloadHash(body)
	return axios.post(
		UPDATE_TEST_CASE_STATUS,
		{
			test_case_id: test_case_id,
			status: status,
			type: testCaseType,
			hash

		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function addTestCase(
	token: string | null,
	type: string,
	test_case_title: string,
	test_case_prefix: string,
	client_api_id: string,
	request_payload: string,
	response_structure: string,
	error_message: string | any,
) {
	let body = {
		type: type,
		test_case_title: test_case_title,
		test_case_prefix: test_case_prefix,
		client_api_id: client_api_id,
		request_payload: request_payload,
		response_structure: response_structure,
		error_message: error_message,
	}
	let hash = getPayloadHash(body)
	return axios.post(
		ADD_NEW_TEST_CASE_FORM_SUBMIT,
		{
			type,
			test_case_title,
			test_case_prefix,
			client_api_id,
			request_payload,
			response_structure,
			error_message,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function updateTestCase(
	test_case_id: string,
	token: string | null,
	test_case_title: string,
	test_case_order: number,
	test_case_prefix: string,
	client_api_id: string,
	request_payload: string,
	response_structure: string,
	error_message: string | any,
	type: string | any
) {
	let body = {
		test_case_title: test_case_title,
		test_case_order: test_case_order,
		test_case_prefix: test_case_prefix,
		client_api_id: client_api_id,
		request_payload: request_payload,
		response_structure: response_structure,
		error_message: error_message
	}
	let hash = getPayloadHash(body)
	return axios.post(
		`${UPDATE_TEST_CASE_FORM_SUBMIT}?test_case_id=${test_case_id}&type=${type}`,
		{
			test_case_title,
			test_case_order,
			test_case_prefix,
			client_api_id,
			request_payload,
			response_structure,
			error_message,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function deleteTestCase(token: string | any, test_case_id: string | any, testCaseType: string | any) {
	let body = {
		test_case_id: test_case_id,
		status: "delete",
		type: testCaseType
	}
	let hash = getPayloadHash(body)
	return axios.post(
		UPDATE_TEST_CASE_STATUS,
		{
			test_case_id: test_case_id,
			status: body.status,
			type: testCaseType,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function testCaseReport(
	token: string | null,
	client_id: string | null,
	account_id: string | null,
	provider_id: string | null
) {
	let body = {
		client_id: client_id,
		account_id: account_id,
		provider_id: provider_id
	}
	let hash = getPayloadHash(body)
	return axios.post(
		TEST_CASE_REPORT,
		{
			client_id,
			account_id,
			provider_id,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function getDashboardData(token: string, clientId: string, currentDate: string, start: string, end: string, currency: string) {
	const url = `${DASHBOARD_DATA_API}?client_id=${clientId}&current_date=${currentDate}&start_date=${start}&end_date=${end}&currency=${currency}`;
	//console.log(url, "url");
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

export function getDashboardGamePlayGraphData(token: string, start_date: string, end_date: string) {
	const url = `${DASHBOARD_GRAPH_GAMEPLAY}?start_date=${start_date}&end_date=${end_date}`;
	//console.log(url, "url");
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

export function getDashboardWalletGraphData(token: string, start_date: string, end_date: string) {
	const url = `${DASHBOARD_GRAPH_WALLET}?start_date=${start_date}&end_date=${end_date}`;
	//console.log(url, "url");
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}


export function getRoundURL(token: string, account_id: string, player_id: string, game_id: string, round_id: string) {
	const safeRoundId = encodeURIComponent(round_id);
	const url = `${RD_URL}?account_id=${account_id}&player_id=${player_id}&game_id=${game_id}&round_id=${safeRoundId}`;

	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

export function getDashboardCategoryData(token: string, start_date: string, end_date: string, currency: string) {
	const url = `${DASHBOARD_CATEGORYWISE}?start_date=${start_date}&end_date=${end_date}&currency=${currency}&type=`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

export function getDashboardTopGamesData(token: string, start_date: string, end_date: string, currency: string, provider_id: string) {
	const url = `${DASHBOARD_TOPGAMES}?start_date=${start_date}&end_date=${end_date}&currency=${currency}&provider_id=${provider_id}&type=`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}


export function getDashboardProviderData(token: string, start_date: string, end_date: string, currency: string, page: number, limit: number) {

	// type = typeof type === 'object' ? type.value : type;

	const url = `${DASHBOARD_PROVIDERWISE}?start_date=${start_date}&end_date=${end_date}&currency=${currency}&page=${page}&limit=${limit}`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

export function getDashboardClientData(token: string, start_date: string, end_date: string, currency: string, type: any) {
	type = typeof type === 'object' ? type.value : type;
	const url = `${DASHBOARD_CLIENTWISE}?start_date=${start_date}&end_date=${end_date}&currency=${currency}&type=${type}`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

export function getProviderBetInfo(token: string | null, provider_id: string, currency: string) {
	let body = {
		provider_id: provider_id,
		currency: currency
	}
	let hash = getPayloadHash(body)
	return axios.post(
		PROVIER_BET_RANGE_INFO,
		{
			provider_id,
			currency,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function addBetRange(
	token: string | null,
	provider_id: string | null,
	allow_multiple_betrange,
	userwise_support,
	clientwise_support,
	is_premium,
	is_custom,
	max_betrange_supported,
	currency: string | null,
	betrange) {
	let body = {
		provider_id: provider_id,
		allow_multiple_betrange: allow_multiple_betrange,
		userwise_support: userwise_support,
		clientwise_support: clientwise_support,
		is_premium: is_premium,
		is_custom: is_custom,
		max_betrange_supported: max_betrange_supported,
		category_id: null,
		currency: currency,
		betrange: betrange
	}
	let hash = getPayloadHash(body)
	return axios.post(
		ADD_MASTER_BET_RANGE,
		{
			provider_id: provider_id,
			allow_multiple_betrange: allow_multiple_betrange,
			userwise_support: userwise_support,
			clientwise_support: clientwise_support,
			is_premium: is_premium,
			is_custom: is_custom,
			max_betrange_supported: max_betrange_supported,
			category_id: null,
			currency: currency,
			betrange: betrange,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function getBetRange(token: string | null, account_id: string | null) {
	let body = {
		account_id: account_id
	}
	let hash = getPayloadHash(body)
	return axios.post(
		GET_BET_RANGE,
		{
			account_id,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function assignBetRange(
	token: string | null,
	account_id: string | null,
	provider_id: string | null,
	betrange_id: string | null,
	betrange
) {
	let body = {
		account_id: account_id,
		provider_id: provider_id,
		betrange_id: betrange_id,
		betrange: betrange
	}
	let hash = getPayloadHash(body)
	return axios.post(
		ASSIGN_BET_RANGE,
		{
			account_id,
			provider_id,
			betrange_id,
			betrange,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function assignAllProviderGames(token: string | null, providers: any, accounts: any, currency: string | null, client_id: string | null) {
	let body = {
		providers: providers,
		accounts: accounts,
		currency: currency,
		client_id: client_id
	}
	let hash = getPayloadHash(body)
	return axios.post(
		ASSIGN_ALL_PROVIDER_GAMES,
		{
			providers,
			accounts,
			currency,
			client_id,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function getAssignSkin(token: string, game_id: string, currency: string) {
	const url = `${GET_ASSIGN_SKIN}?game_id=${game_id}&currency=${currency}`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

export function updateGameSkin(token: string | null, data: any) {
	let hash = getPayloadHash(data);
	data = {
		...data,
		hash
	}
	return axios.post(
		UPDATE_ASSIGN_SKIN,
		data,
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function getProviderLogs(token: string | null, data: any, page, limit) {
	let payload = {
		account_id: data.accountId?.trim() || '',
		request_id: data.requestId || '',
		player_id: data.playerId?.trim() || '',
		round_id: data.roundId || '',
		provider_id: data.provider || '',
		start_time: data.startDate || '',
		end_time: data.endDate || '',
		page: page || 1,
		limit: limit || 10
	};
	let hash = getPayloadHash(payload);
	let payload1 = {
		...payload,
		hash: hash
	}
	return axios.post(
		GET_PROVIDER_API_LOG,
		payload1,
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function getClientLogs(token: string | null, data: any, page, limit) {
	//console.log("payload data===>", data)
	const payload = {
		request_id: data.requestId || '',
		client_id: data.clientId || '',
		account_id: data.accountId || '',
		start_time: data.startDate || '',
		end_time: data.endDate || '',
		page: page || 1,
		limit: limit || 10,
		type: "client"
	};
	let hash = getPayloadHash(payload);
	let payload1 = {
		...payload,
		hash: hash
	}
	return axios.post(
		GET_CLIENT_API_LOG,
		payload1,
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function getResponseGraph(token: string | null, data: any) {
	const payload = {
		rangeInSeconds: data.rangeInSeconds || '',
		provider_id: data.providerId || '',
	};
	let hash = getPayloadHash(payload);
	let payload1 = {
		...payload,
		hash: hash
	}
	return axios.post(
		GET_RESPONSE_GRAPH,
		payload1,
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function getEvolutionSkinList(token: string, currency, page, limit) {
	const url = `${GET_EVO_SKIN_LIST}?currency=${currency}&page=${page}&limit=${limit}`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

export function addEvoSkin(token: string | null, data: any) {
	console.log("add evo skin data===>", data)
	const payload = {
		parent_skin_id: data.parentId || null,
		provider_account_id: data.provider_account_id,
		provider_id: data.provider,
		currency: data.currency,
		skin_code: data.skinCode,
		skin_name: data.skinName,
		betrange_min: parseInt(data.minRange),
		betrange_max: parseInt(data.maxRange),
		is_premium_skin: false
	};
	console.log("add evo skin payload===>", payload)
	let hash = getPayloadHash(payload);
	let payload1 = {
		...payload,
		hash: hash
	}
	return axios.post(
		ADD_EVO_SKIN,
		payload1,
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function getSkinDetails(token: string, id: string, currency: string) {
	const url = `${GET_SKIN_DETAILS}?_id=${id}&currency=${currency}`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

export function updateSkinDetails(token: string | null, data: any) {
	const payload = {
		_id: data._id,
		provider_id: data.provider_id,
		parent_skin_id: data.parent_skin_id || null,
		currency: data.betrange_currency,
		skin_code: data.skin_code,
		skin_name: data.skin_name,
		allow_multiple_bet: data.allow_multiple_bet,
		bet_range_count: data.bet_range_count,
		is_user_wise: data.is_user_wise,
		is_premium_skin: data.is_premium_skin,
		is_visible_for_client: data.is_visible_for_client,
		is_varying_currency_wise: data.is_varying_currency_wise,
		is_default: data.is_default,
		betrange_min: parseFloat(data.betrange_min),
		betrange_max: parseFloat(data.betrange_max),
		status: data.status
	}
	let hash = getPayloadHash(payload);
	let payload1 = {
		...payload,
		hash: hash
	}
	return axios.post(
		UPDATE_SKIN_DETAILS,
		payload1,
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
};

export function evoSkinStatusUpdate(token: string | null, skinId: string | null, status: string | null) {
	let body = {
		skin_id: skinId,
		status: status
	}
	let hash = getPayloadHash(body)
	return axios.post(
		EVO_SKIN_STATUS_UPDATE,
		{
			skin_id: skinId,
			status: status,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function getEvoSkinRangeList(token: string, account_id: string) {
	const url = `${GET_EVO_SKIN_RANGE_LIST}?account_id=${account_id}`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
};

export function assignEvoSkins(
	token: string | null,
	account_id: string | null,
	provider_id: string | null,
	skin_ids
) {
	let body = {
		account_id: account_id,
		provider_id: provider_id,
		skin_ids: skin_ids
	}
	let hash = getPayloadHash(body)
	return axios.post(
		ASSIGN_EVO_SKINS,
		{
			account_id,
			provider_id,
			skin_ids,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function providerCurrencyList(
	token: string | null,
	provider_id: string | null
) {
	let body = {
		provider_id: provider_id
	}
	let hash = getPayloadHash(body)
	return axios.post(
		PROVIDER_CURRENCY_LIST,
		{

			provider_id,

			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function providerCategoryList(
	token: string | null,
	provider_id: string | null
) {
	let body = {
		provider_id: provider_id
	}
	let hash = getPayloadHash(body)
	return axios.post(
		PROVIDER_CATEGORY_LIST,
		{
			provider_id,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}



export function getGlobalMaintenanceModeDetails(token: string) {
	const url = `${getGlobalMaintenanceMode}`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
};


export function setGlobalMaintenanceModeDetails(token: string | null, maintenance_mode_on: boolean | false, bypassClientIds: string[]) {
	let body = {
		maintenance_mode_on: maintenance_mode_on,
		bypassClientIds: bypassClientIds
	}
	let hash = getPayloadHash(body)
	return axios.post(
		updateGlobalMaintenanceMode,
		{
			...body,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

/**
 * Launch game for a specific player
 * @param token - Authentication token
 * @param data - Object containing user_id and game_id
 */
export function launchGameForPlayer(token: string | null, data: { user_id: string; game_id: string }) {
	const body = {
		user_id: data.user_id,
		game_id: data.game_id
	};
	const hash = getPayloadHash(body);

	return axios.post(
		LAUNCH_GAME_FOR_PLAYER_URL,
		{
			user_id: data.user_id,
			game_id: data.game_id,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function getAssignFreeSpinProvider(token: string | null, clientID: string) {
	let url = `${GET_ASSIGNED_FREE_SPIN_PROVIDER_}?client_id=${clientID}`;
	return axios.get(url, { headers: { "Content-Type": "application/json", token: `${token}` } });
}

export function setAssignFreeSpinProvider(token: string | null, client: string[], provider: any) {
	let body = {
		client_ids: client,
		provider_ids: provider,
	}
	let hash = getPayloadHash(body)
	return axios.post(
		SET_ASSIGNED_FREE_SPIN_PROVIDER_,
		{
			client_ids: client,
			provider_ids: provider,
			hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function allAndAssignedProvidersByClientid(token: string | null, client_id: string) {
	let url = `${ALL_AND_ASSIGNED_PROVIDERS_BY_CLIENTID}?client_id=${client_id}`;
	return axios.get(url, {
		headers: {
			"Content-Type": "application/json",
			token: `${token}`,
		},
	});
}

export function providerDetailsUpdate(token: string | null, provider_id: any, formData: FormData) {
	let url = `${PROVIDER_DETAILS_UPDATE}?provider_id=${provider_id}`;

	const formObj = Object.fromEntries((formData as any).entries());
	let hash = getPayloadHash(formObj);
	formData.append("hash", hash);

	return axios.post(
		url,
		formData,
		{
			headers: {
				"Content-Type": "multipart/form-data",
				token: `${token}`,
			},
		}
	);
}

export function providerGeneralCredentialUpdate(token: string | null, body: any) {
	let hash = getPayloadHash(body);
	return axios.post(
		PROVIDER_GENERAL_CREDENTIAL_UPDATE,
		{
			...body,
			hash: hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function providerTechnicalCredentialUpdate(token: string | null, body: any) {
	let hash = getPayloadHash(body);
	return axios.post(
		PROVIDER_TECHNICAL_CREDENTIAL_UPDATE,
		{
			...body,
			hash: hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function addProviderAccount(token: string | null, body: any) {
	let hash = getPayloadHash(body);
	return axios.post(
		ADD_PROVIDER_ACCOUNT,
		{
			...body,
			hash: hash
		},
		{
			headers: {
				"Content-Type": "application/json",
				token: `${token}`,
			},
		}
	);
}

export function addMainProvider(token: string | null, formData: FormData) {
	const formObj = Object.fromEntries((formData as any).entries());
	let hash = getPayloadHash(formObj);
	formData.append("hash", hash);

	return axios.post(
		ADD_MAIN_PROVIDER,
		formData,
		{
			headers: {
				"Content-Type": "multipart/form-data",
				token: `${token}`,
			},
		}
	);
}